<sc-title *ngIf="title" type="h2" content="Información de tu cliente" color="black"></sc-title>
<p *ngIf="editMode && title" class="section-subtitle">Con datos básicos de tu cliente podemos lograr una mejor propuesta</p>
<form [formGroup]="formGroup" *ngIf="editMode">
  <div class="fields-block">
    <sc-person-search
      [insuredData]="insuredData"
      [documentTypeOptions]="documentTypeOptions"
      [defaultDocumentTypeOption]="defaultDocumentTypeOption"
      [validateContact]="validateContact"
      [policyProduct]="policyProduct"
      [customNotFoundMessage]="'No pudimos encontrar en nuestros registros una persona para el %documentType% ingresado. Comunicate con la <a href=https://serviciospas.sancristobal.com.ar/portal/6/create/182 target=_blank>mesa de ayuda</a> para poder realizar la cotización.'"
      (personInfoSelected)="handlePersonInfoSelected($event)"
      (insuredVerified)="handleInsuredVerification($event)"
      ></sc-person-search>
    <div class="row" [hidden]="!personInfoSelected.insured">
      <div class="col-md-9 col-12 postal-code-wrapper">
        <sc-select
          #postalCodeControl
          formControlName="postalCode"
          label="Código postal"
          placeholder="Ej: 2000"
          enableSearch="true"
          objectValue="name"
          [itemsAsync$]="postalCodeOptions$"
          [loading]="loadingPostalCode"
          (keyup)="getCitiesOnKeyUp($event)"
        ></sc-select>
      </div>
    </div>
  </div>
  <div class="buttons-block" *ngIf="formGroup.valid && (insuredVerified || insuredData)">
    <div class="row">
      <div class="col-md-5 col-12">
        <sc-button type="primary" class="submit-btn" size="large" (onClick)="onSubmit()" id="begin-to-quote">{{ btnLabel }}</sc-button>
      </div>
    </div>
  </div>
</form>
<div *ngIf="!editMode && personInfoSelected?.insured" class="section-submitted-data">
  <div class="">
    <span>{{personInfoSelected.insured.firstName}} {{personInfoSelected.insured.lastName}}</span>
    <br>
    <span>{{personInfoSelected.documentType.value}}: {{personInfoSelected.idNumber}}</span>
    <br>
    <ng-container *ngIf="taxIVA">
      <span >{{ ['N/D',''].indexOf(personInfoSelected.insured.taxIVA.name) > -1 ? 'Consumidor final' : personInfoSelected.insured.taxIVA.name }}</span>
      <br>
    </ng-container>
    <span>{{formGroup.value.postalCode?.name}}</span>
  </div>
</div>
